export default __webpack_public_path__ + "static/media/toolbar-bold.f5e68f1b.svg";